<hr width="85%">
<footer class="app-footer">
  <!-- First Row - Navigation Links -->
  <div class="footer-row footer-nav">
    <div class="footer-column">
      <img src="/assets/logo.svg" alt="GS1 Logo" class="footer-logo">
      <div class="footer-links">
        <a href="https://gs1pt.org/adesao/" class="footer-title">Adesão</a>
        <a href="https://associado.gs1pt.org/#/login?returnUrl=%2Fvista-entidades" class="footer-title">
            Área do Associado
        </a>
      </div>
    </div>
    <div class="footer-column">
      <span class="footer-title">Quem Somos</span>
      <a target="_blank" href="https://gs1pt.org/sobre-nos/" class="footer-link-small">GS1 Portugal</a>
      <a target="_blank" href="https://gs1pt.org/sobre-nos/estrutura/" class="footer-link-small">Estrutura</a>
      <a target="_blank" href="https://gs1pt.org/contactos/" class="footer-link-small">Contactos</a>
      <a target="_blank" href="https://gs1pt.org/atividade/" class="footer-link-small">Atividade</a>
      <a target="_blank" href="https://gs1pt.org/1-4-gs1-internacional/" class="footer-link-small">GS1 Internacional</a>
      <a target="_blank" href="https://gs1pt.org/1-6-carreira/" class="footer-link-small">Carreira</a>
    </div>
    <div class="footer-column">
      <span class="footer-title">Códigos e Standards</span>
      <a target="_blank" href="https://gs1pt.org/o-sistema-gs1/" class="footer-link-small">O Sistema GS1</a>
      <a target="_blank" href="https://gs1pt.org/2-obter-codigo-de-barras/" class="footer-link-small">Obter código de
        barras</a>
      <a target="_blank" href="https://gs1pt.org/2-2-digito-controlo/" class="footer-link-small">Dígito de Controlo</a>
      <a target="_blank" href="https://gs1pt.org/2-3-validacao/" class="footer-link-small">Validação de códigos</a>
      <a target="_blank" href="https://gs1pt.org/saude/" class="footer-link-small">Setor da Saúde</a>
      <a target="_blank" href="https://gs1pt.org/parceiros-tecnologicos/" class="footer-link-small">Parceiros
        Tecnológicos</a>
      <a target="_blank" href="https://gs1pt.org/2-6-condicoes-comerciais/" class="footer-link-small">Condições
        Comerciais</a>
      <a target="_blank" href="https://gs1pt.org/2-7-guias-de-utilizacao/" class="footer-link-small">Guias de
        Utilização</a>
    </div>
    <div class="footer-column">
      <span class="footer-title">Serviços</span>
      <a target="_blank" href="https://gs1pt.org/3-1-consultoria/" class="footer-link-small">Consultoria</a>
      <a target="_blank" href="https://gs1pt.org/3-8-calculo-de-emissoes-de-dioxido-de-carbono-equivalente/"
        class="footer-link-small">Pegada de Carbono</a>
      <a target="_blank" href="https://gs1pt.org/3-1-estudos-de-niveis-de-servicos/" class="footer-link-small">Estudos
        de Mercado</a>
      <a target="_blank" href="https://gs1pt.org/3-3-fatura-eletronica/" class="footer-link-small">Fatura Eletrónica</a>
      <a target="_blank" href="https://gs1pt.org/3-1-lean-green/" class="footer-link-small">Lean & Green</a>
      <a target="_blank" href="https://gs1pt.org/3-6-sync-pt/" class="footer-link-small">Plataforma Sync PT</a>
      <a target="_blank" href="https://gs1pt.org/3-7-validata/" class="footer-link-small">Qualidade Dados</a>
      <a target="_blank" href="https://gs1pt.org/3-5-rastreabilidade/" class="footer-link-small">Serviços de
        Rastreabilidade</a>
      <a target="_blank" href="https://gs1pt.org/relatorios-de-sustentabilidade/" class="footer-link-small">Relatórios
        de Sustentabilidade</a>
    </div>
    <div class="footer-column">

      <span class="footer-title">Sustentabilidade</span>
      <a target="_blank" href="https://gs1pt.org/sustentabilidade-no-plano-estrategico-2022-2024/"
        class="footer-link-small">Sustentabilidade no plano estratégico</a>
      <a target="_blank" href="https://gs1pt.org/topicos-materiais/" class="footer-link-small">Tópicos Materiais</a>
    </div>
    <div class="footer-column">
      <span class="footer-title">Formação</span>
      <a target="_blank" href="https://gs1pt.org/5-1-catalogo-formativo/" class="footer-link-small">Catálogo
        Formativo</a>
      <a target="_blank" href="https://gs1pt.org/testemunhos/" class="footer-link-small">Testemunhos</a>
    </div>
    <div class="footer-column">
      <span class="footer-title">Eventos & Notícias</span>
      <a target="_blank" href="https://gs1pt.org/calendario/" class="footer-link-small">Calendário</a>
      <a target="_blank" href="https://gs1pt.org/portefolio/" class="footer-link-small">Portefólio</a>
      <a target="_blank" href="https://gs1pt.org/6-1-e-newslleters/" class="footer-link-small">e-Newsletters</a>
      <a target="_blank" href="https://gs1pt.org/noticias-e-tendencias/" class="footer-link-small">Notícias e
        Tendências</a>
    </div>
  </div>
  <hr style="width: 85%;">
  <!-- Second Row - Contact Info -->
  <div class="footer-row footer-contact">
    <div class="footer-column">
      <div class="social-icons">
        <a href="https://www.linkedin.com/company/gs1-portugal" class="social-icon" aria-label="LinkedIn">
          <i class="bi bi-linkedin"></i>
        </a>
        <a href="https://www.instagram.com/gs1portugal/" class="social-icon" aria-label="Instagram">
          <i class="bi bi-instagram"></i>
        </a>
        <a href="https://www.facebook.com/gs1portugal/" class="social-icon" aria-label="Facebook">
          <i class="bi bi-facebook"></i>
        </a>
        <a href="https://www.youtube.com/user/GS1PT/featured" class="social-icon" aria-label="YouTube">
          <i class="bi bi-youtube"></i>
        </a>
      </div>
    </div>
    <div class="footer-column">
      <div class="contact-info">
        <a>
          <strong>Geral</strong> +(351) 21 752 07 51
        </a>
        <a>
          <strong>Apoio ao Associado</strong> +(351) 21 752 07 40
        </a>
        <a>
          Chamadas para a rede fixa nacional
        </a>
      </div>
    </div>
    <div class="footer-column">
      <div class="contact-info">
        <a>Das 9h00 às 18h00</a>
        <a>Encerrado aos fins-de-semana e feriados</a>
      </div>
    </div>
    <div class="footer-column">
      <div class="contact-info">
        <a>Estrada do Paço do Lumiar, Campus do Lumiar, Edifício K3</a>
        <a>1649-038 Lisboa</a>
      </div>
    </div>
  </div>

  <!-- Third Row - Copyright -->
  <div class="footer-row footer-copyright">
    <div class="copyright-text">
      © GS1 é uma marca registada da GS1 Portugal-Codipor.
      <a target="_blank" href="https://gs1pt.org/politica-de-cookies/" class="footer-link-small">Política de
        Cookies</a>.
      <a target="_blank" href="https://gs1pt.org/politica-de-privacidade/" class="footer-link-small">Política de
        Privacidade</a>.
      <a target="_blank" href="https://www.livroreclamacoes.pt/inicio" class="footer-link-small">Livro de reclamações
        eletrónico</a>.
    </div>
  </div>
</footer>